import { Perfil } from './../../model/perfil';
import { Component, OnInit } from '@angular/core';
import { PerfilService } from './../../service/perfil/perfil.service';
import { ModalConfirmService } from '../../modules/modals/confirm-window';

import 'rxjs/add/operator/catch';
import { ModalAlertService } from '../../modules/modals/alert-window';
import { DataService } from 'src/app/service/data/data.service';
import { ModuloService } from 'src/app/service/modulo/modulo.service';
import { Module } from 'src/app/model/module';
import { UserDetails } from '../../model/userdetails';


@Component({
  selector: 'app-gerencia',
  templateUrl: './gerencia.component.html',
  styleUrls: ['./gerencia.component.css']
})
export class GerenciaComponent implements OnInit {
  profiles: Array<Perfil>;
  currentUser: any;
  public permissaoExcluir: boolean = false;


  constructor(private perfilService: PerfilService,
    private confirmModalService: ModalConfirmService,
    private alertModalService: ModalAlertService,
    private dataService: DataService,
    private moduloService: ModuloService) { }
    

  ngOnInit() {
    this.LoadProfiles();

    let user: UserDetails = JSON.parse(localStorage.getItem('idUser'));

    this.moduloService.Get(user.is_Rus).subscribe((modulos: Array<Module>) => {
      if (modulos)
        this.dataService.changeModules(modulos.map(value => { return value.is_Rmd }));

      this.dataService.currentModules.subscribe(modulos => {

        if (modulos) {
          this.permissaoExcluir = modulos.find((value) => value == 5) != null;
        }

      });
    });
  }

  LoadProfiles() {
    this.dataService.currentUserDetails.subscribe(user => {
      this.currentUser = user;
      

      this.perfilService.OnSearchListaPerfil(user.is_Ressarcimento.toString(), user.is_Rus.toString()).subscribe((res: Array<Perfil>) => {
        this.profiles = res;
      })
    });
  }

  DeleteProfile(profile: Perfil) {
    this.confirmModalService.show("Excluir perfil", "Tem certeza que deseja excluir o perfil de " + profile.nm_Nome + "?",
      () => {
        this.perfilService.Delete(profile.is_Rus, this.currentUser["is_Rus"])
          .catch((err) => {
            this.alertModalService
              .show("Atenção", "Falha ao tentar excluir o perfil de " + profile.nm_Nome);
            return null;
          })
          .subscribe((res) => {
            this.LoadProfiles();
            this.alertModalService.show("Excluir perfil", res["mensagemRetorno"]);
          });
      })
  }
}
